export const DATE_PICKER_COMPONENT_NAME = 'date-picker';
